// extracted by mini-css-extract-plugin
module.exports = {"s1c8mznh":"s1c8mznh","su0lww4":"su0lww4"};